import axios from "axios";

const BASE = process.env.REACT_APP_BASEURL?.endsWith("/")
  ? process.env.REACT_APP_BASEURL
  : `${process.env.REACT_APP_BASEURL}/`;

const TICKETS_CONTAINER =
  process.env.AZURE_BLOB_CONTAINER_TICKETS || "tickets",
  LOCATIONS_CONTAINER =
    process.env.AZURE_BLOB_CONTAINER_LOCATIONS || "locations";

export async function getSecureUrl(imgPath, expirySeconds = 60) {
  if (!imgPath) return null;

  if (/^https?:\/\//i.test(imgPath)) return imgPath;

  try {
    let key = imgPath;

    if (/ticket/i.test(imgPath)) key = `${TICKETS_CONTAINER}/${imgPath}`;
    if (/location/i.test(imgPath)) key = `${LOCATIONS_CONTAINER}/${imgPath}`;


    const resp = await axios.get(`${BASE}secure-download`, {
      params: {
        key,
        expiry: expirySeconds,
      },
      headers: {
        Accept: "application/json",
      },
      withCredentials: true,
    });

    return resp?.data?.url || resp?.data?.data?.url || null;
  } catch (err) {
    console.error("Signed URL failed:", err);
    return null;
  }
}
